import InfoOutlined from '@mui/icons-material/InfoOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import usePopup from 'src/logic/hooks/use-popup';
import Category from 'src/logic/models/catalogue/Category';
import { getCategoryFaqs } from 'src/logic/services/catalogue/faqs';
import { sm } from 'src/site-map';
import FaqPopup from './FaqPopup';

const ClassificationBanner = ({ category }: { category: Category }) => {
  const faqPopup = usePopup();
  const { pathname } = useRouter();
  const isOnCategoryPage = pathname === sm.catalogue.categories.categoryId('[id]').url;

  return (
    <>
      <div
        style={{
          marginBlock: '1rem',
          backgroundColor: '#fff',
          borderRadius: '8px',
          padding: '1.5rem',
          width: '100%',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1em' }}>
          <Typography color='#3A3E50' fontWeight={700} fontSize={21}>
            {category.name}
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {!isOnCategoryPage && category.slug && (
              <Link href={sm.catalogue.categories.categoryId(category.slug).url}>
                <Button
                  type='button'
                  color='primary'
                  variant='text'
                  sx={{ fontWeight: 700, fontSize: 14 }}
                  endIcon={<OpenInNewIcon fontSize='inherit' />}
                >
                  Link
                </Button>
              </Link>
            )}
            <Typography color='#8B8D98' fontWeight={500} fontSize={14}>
              Need help?{' '}
              <Button
                type='button'
                color='primary'
                variant='text'
                sx={{ fontWeight: 700, fontSize: 14 }}
                startIcon={<InfoOutlined />}
                onClick={faqPopup.handleOpen}
              >
                Read FAQ
              </Button>
            </Typography>
          </div>
        </div>
        {category.description ? (
          <Typography mt={1} fontWeight={400} fontSize={12} color='#8B8D98'>
            {category.description}
          </Typography>
        ) : null}
      </div>

      <FaqPopup
        open={faqPopup.isOpen}
        onClose={faqPopup.handleClose}
        queryKey={['CATEGORY_FAQS', category.id]}
        fetchFaqs={() => getCategoryFaqs(category.id)}
      />
    </>
  );
};

export default ClassificationBanner;
